import { PreferencesFormType, SignFormParams } from '../types';
import { get, post } from './axios';

const URLS = {
  getFormContent: 'get-form-content',
  signForm: 'sign-form',
  getPreferencesForm: 'evo_get-cl-notif-prefs-v2',
  setPreferencesForm: 'evo_update-cl-notif-prefs'
};

const formsApi = {
  getFormContent: (formType: string, formId: number) =>
    get(URLS.getFormContent, { form_type: formType, form_id: formId }),
  signForm: (params: SignFormParams) => post(URLS.signForm, params),
  getPreferencesForm: () => get(URLS.getPreferencesForm),
  setPreferencesForm: (params: Partial<PreferencesFormType>) =>
    post(URLS.setPreferencesForm, params)
};

export default formsApi;
